import { Product } from "../Model/Product";
import { ProductRepository } from "../Repository/ProductRepository";

export interface CreateProductUseCase {
  invoke: (data: Product) => Promise<number>;
}

export class CreateProduct implements CreateProductUseCase {

  private productRepo: ProductRepository;

  constructor(_ProductRepo: ProductRepository) {
    this.productRepo = _ProductRepo;
  }

  async invoke(data: Product){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.productRepo.createProduct(data);
    return created;
  }
}